import { RestSlice } from '../../redux/rest.slice';
import { ImportConfiguration } from '@rcp/types';
import { localizationService, Resource } from 'src/services';

export const importConfigurationSlice = new RestSlice<ImportConfiguration>(
	localizationService.getLocalizedString('cccImportFile.configuration'),
	Resource.CccImportConfigurations
);
export default importConfigurationSlice.rests.reducer;
